import { render } from "./PrivacyPolicy.vue?vue&type=template&id=e79014d6&scoped=true"
const script = {}

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=e79014d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79014d6"]])

export default __exports__